import { render, staticRenderFns } from "./DeanRegistersRootView.vue?vue&type=template&id=0f650360"
import script from "./DeanRegistersRootView.vue?vue&type=script&lang=js"
export * from "./DeanRegistersRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports